module.exports = __webpack_public_path__ + "img/music_tt.8f2f3b54.png";